import { ShieldAlert } from "lucide-react";

export function ImpersonationBanner() {
  const adminTok = typeof localStorage !== "undefined" ? localStorage.getItem("mw_imp_admin") : null;
  if (!adminTok) return null;
  const label = localStorage.getItem("mw_imp_label") || "Nutzer";

  const exit = () => {
    localStorage.setItem("mw_access", adminTok);
    localStorage.setItem("mw_refresh", localStorage.getItem("mw_imp_admin_refresh") || "");
    localStorage.removeItem("mw_imp_admin");
    localStorage.removeItem("mw_imp_admin_refresh");
    localStorage.removeItem("mw_imp_label");
    window.location.href = "/app/admin/users";
  };

  return (
    <div
      className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-950"
      data-testid="impersonation-banner"
    >
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span>Du bist als <b>{label}</b> eingeloggt (Impersonation).</span>
      <button
        onClick={exit}
        data-testid="impersonation-exit"
        className="rounded-full bg-amber-950 px-3 py-1 text-xs font-semibold text-amber-50 transition-colors hover:bg-amber-900"
      >
        Zurück zu Admin
      </button>
    </div>
  );
}
